import { Link } from "react-router-dom";
import { Headphones, ArrowRight } from "lucide-react";

export default function PodcastTeaser() {
  return (
    <section
      data-testid="podcast-teaser"
      className="py-16 md:py-20 px-6 md:px-12 lg:px-20 relative"
    >
      <div className="max-w-4xl mx-auto">
        <Link
          to="/podcast"
          data-testid="podcast-teaser-link"
          className="group flex flex-col sm:flex-row items-center gap-6 bg-[#2F3A56] rounded-3xl p-8 md:p-10 hover:shadow-[0_12px_40px_rgba(47,58,86,0.3)] transition-all duration-300"
        >
          {/* Cover */}
          <div className="w-24 h-24 md:w-28 md:h-28 rounded-2xl overflow-hidden flex-shrink-0">
            <img
              src={`${process.env.PUBLIC_URL}/screenshots/sally.webp`}
              alt="Sally — NeuroNest Podcast host"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text */}
          <div className="flex-1 text-center sm:text-left">
            <span className="inline-block text-[10px] uppercase tracking-widest text-brand-teal font-semibold mb-2">
              New Episode
            </span>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-2">
              The NeuroNest Podcast
            </h3>
            <p className="text-sm text-white/50 leading-relaxed">
              Conversations about neurodiversity, sensory-safe design, and building
              tools that respect how your brain works.
            </p>
          </div>

          {/* Arrow */}
          <div className="flex items-center gap-2 text-brand-teal text-sm font-medium group-hover:gap-3 transition-all duration-300 flex-shrink-0">
            Listen <ArrowRight size={16} />
          </div>
        </Link>
      </div>
    </section>
  );
}
